import { create } from 'zustand';

type ExpediteFields = {
  name: string;
  email: string;
  position: string;
  extension: number | '';
  cellPhone: string;
  disclaimer: string;
  updatesEmail: string;
  linkedin: string;
  hasLoadbaseBanner: boolean;
  hasWarehouse411Banner: boolean;
  pictureUrl?: string;
};

type ExpediteStore = ExpediteFields & {
  setField: <K extends keyof ExpediteFields>(key: K, value: ExpediteFields[K]) => void;
};

export const useExpediteStore = create<ExpediteStore>((set) => ({
  company: { id: 1, title: 'Sierra Expediting' },
  name: 'John Doe',
  email: 'john.doe@sendsierra.com',
  position: 'Dispatch',
  extension: 101,
  cellPhone: '(916) 123-4567',
  disclaimer: 'Sierra Expediting INC emails and domains end with (@sierraexpedite.com) and (@sendsierra.com). Any other emails you may have been communicated through should be deleted and' +
    ' reported. The content of this email is confidential and intended for the recipient specified in message only. It is strictly forbidden to share any part of this message with any third party, without a written consent of the sender. If you received this message by mistake, please reply to this message and follow with its deletion, so that we can ensure such a mistake does not occur in the future.',
  updatesEmail: 'tracking@sendsierra.com',
  linkedin: '',
  hasLoadbaseBanner: true,
  hasWarehouse411Banner: true,
  pictureUrl: '',

  setField: (key, value) => set((state) => ({ ...state, [key]: value })),
}));